import React, { useCallback, useEffect, useState, Fragment } from 'react';
import MUIAutocomplete from '@mui/material/Autocomplete';
import MUITextField from '@mui/material/TextField';
import MUICircularProgress from '@mui/material/CircularProgress';
import MuiBox from '@mui/material/Box';
import TextField from '../form/components/TextField.component';
import Error from '../form/components/Error.component';
import { useController, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../api/request';
import { API as mexalAPI } from '../../module/mexal/index';
import _ from 'lodash';

const MexalSuppliers = ({ name, required, id, label, api = mexalAPI.mexalSuppliers, ...props }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { jwt } = useSelector((state) => state.login);
  const {
    control,
    setValue,
    formState: { errors, defaultValues },
  } = useFormContext();

  const {
    field: { ref, onChange, value },
  } = useController({ name, control, rules: { required } });

  const savedValue = defaultValues?.[name];

  const fetchData = useCallback(() => {
    setLoading(true);
    fetchAPI(api, {}, {}, {}, jwt)
      .then((response) => {
        setLoading(false);
        setOptions(Array.isArray(response) ? response : []);
      })
      .catch(() => {
        setLoading(false);
        setOptions([]);
      });
  }, [api, jwt]);

  useEffect(() => {
    if (!savedValue) {
      fetchData();
    }
  }, [savedValue, fetchData]);

  if (savedValue) {
    return (
      <TextField
        name={name}
        id={id}
        label={label}
        required={required}
        disabled
        {...props}
      />
    );
  }

  const selectedOption = options.find((opt) => opt.id === value) || null;

  return (
    <MuiBox display='flex' flexDirection='column'>
      <MUIAutocomplete
        ref={ref}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={options}
        value={selectedOption}
        getOptionLabel={(option) => option?.name || ''}
        isOptionEqualToValue={(option, val) => option.id === val?.id}
        onChange={(e, data) => {
          onChange(data ? data.id : null);
          if (data) {
            setValue('label', data.mexal_research_name ?? '');
            setValue('address', data.mexal_address ?? '');
            setValue('phone', data.mexal_phone ?? '');
            setValue('email', data.mexal_email ?? '');
            setValue('website', data.mexal_website ?? '');
            setValue('company_name', data.mexal_company ?? '');
            setValue('vat_number', data.mexal_vat_number ?? '');
            setValue('sdi_code', data.mexal_sdi_code ?? '');
          }
        }}
        filterOptions={(opts, state) => {
          const inputValue = state.inputValue.toLowerCase();
          return opts.filter((option) =>
            _.includes(option.name?.toLowerCase(), inputValue)
          );
        }}
        renderOption={(renderProps, option) => (
          <li {...renderProps} key={option?.id}>
            {option.name}
          </li>
        )}
        loading={loading}
        renderInput={(params) => (
          <MUITextField
            {...params}
            label={label}
            required={required}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loading ? (
                    <MUICircularProgress color='inherit' size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            }}
            error={!!errors[name]?.message}
          />
        )}
      />
      <Error error={errors[name]?.message} />
    </MuiBox>
  );
};

export default MexalSuppliers;
